export type UserRole = "USER" | "MODERATOR" | "ADMIN"

export const useSessionRole = () => {
	const userJson = sessionStorage.getItem("user")
	if (!userJson) {
		return { role: "USER" as UserRole, isAdmin: false, isModerator: false }
	}

	try {
		const user = JSON.parse(userJson)
		const role = (user?.role ?? "USER") as UserRole
		return {
			role,
			isAdmin: role === "ADMIN",
			isModerator: role === "MODERATOR" || role === "ADMIN",
		}
	} catch {
		return { role: "USER" as UserRole, isAdmin: false, isModerator: false }
	}
}
